import Image from 'next/image'
import React from 'react'

const SRP_ICONS = 'https://storage.googleapis.com/offermgmt-prod/offermgmt/images/logos/srp_icons'

export const srpHostedIcon = (file: string, size = 24): React.FC => {
  const HostedIcon = () => <Image alt='' height={size} src={`${SRP_ICONS}/${file}`} width={size} />
  return HostedIcon
}
